import { Checkbox } from "@hortis/ui/checkbox";
import { type Row, type RowData, type Table } from "@tanstack/react-table";
import type { ReactNode } from "react";
import { handleRowSelection } from "./row-selection";

export interface DataTableCehckboxCellProps<TData extends RowData> {
  table: Table<TData>;
  row: Row<TData>;
  children?: ReactNode;
}

export function DataTableCheckboxCell<TData extends RowData>({
  table,
  row,
  children,
}: DataTableCehckboxCellProps<TData>) {
  return (
    <div className="flex items-center gap-3">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        className="absolute left-0 top-0 h-full w-14"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleRowSelection({ selected: !row.getIsSelected(), row, table });
        }}
      />
      <Checkbox
        checked={row.getIsSelected()}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onChange={(e) => {
          handleRowSelection({ selected: e.target.checked, row, table });
        }}
        aria-label="Select row"
      />
      {children}
    </div>
  );
}
